import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { StatusBadge, EmptyState } from "@/components/admin/shared";
import { Loader2, Search } from "lucide-react";

export const ReportViewer = ({ type, onClose }) => {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    if (!type) { setData(null); return; }
    setQ("");
    api.get(`/reports/${type}?format=json`).then((r) => setData(r.data)).catch(() => setData({ headers: [], keys: [], rows: [] }));
  }, [type]);

  const rows = (data?.rows || []).filter((r) => !q || Object.values(r).join(" ").toLowerCase().includes(q.toLowerCase()));

  return (
    <Dialog open={!!type} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-[95vw] w-[1200px] max-h-[90vh] flex flex-col" data-testid="report-viewer">
        <DialogHeader><DialogTitle>{data?.title || "Report"} <span className="text-sm font-normal text-slate-400">· {rows.length} records</span></DialogTitle></DialogHeader>
        <div className="relative">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search in report…" className="pl-9 h-10 rounded-xl" data-testid="report-viewer-search" />
        </div>
        <div className="overflow-auto flex-1 border border-slate-100 rounded-xl">
          {!data ? <div className="py-16 flex justify-center"><Loader2 className="animate-spin text-slate-400" /></div>
            : rows.length === 0 ? <EmptyState text="No records" /> : (
              <table className="w-full text-sm" data-testid="report-viewer-table">
                <thead className="sticky top-0 bg-[#081226] text-white">
                  <tr>{data.headers.map((h) => <th key={h} className="text-left text-xs font-semibold px-3 py-2.5 whitespace-nowrap">{h}</th>)}</tr>
                </thead>
                <tbody>
                  {rows.map((r, i) => (
                    <tr key={i} className="border-b border-slate-50 even:bg-slate-50/60" data-testid="report-viewer-row">
                      {data.keys.map((k) => <td key={k} className="px-3 py-2 whitespace-nowrap text-slate-700">{k === "status" ? <StatusBadge status={r[k]} /> : String(r[k])}</td>)}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
